export default __webpack_public_path__ + "media/images/theme_apple/pinstripes-41c73e4c24215a15f22273c32f7cb761.png";